var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.625,
    stroke: "currentColor",
    strokeWidth: 0.75
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.84265 12.1573L12.1573 12.1573",
    stroke: "currentColor",
    strokeWidth: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.31453 4.7734L10.6102 6.06909M6.42181 10.2575C6.27115 9.59459 5.7589 9.08234 5.09599 8.93167M6.33142 10.3479L4.67413 10.6794L5.00559 9.02207L10.0787 4.02763C10.4704 3.63591 10.6404 3.92969 11.0321 4.32141C11.4238 4.71313 11.7176 4.88311 11.3259 5.27483L6.33142 10.3479Z",
    stroke: "currentColor",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditCircle);
export default __webpack_public_path__ + "static/media/edit-circle.8a55d78a511c076f6c7410fe35eb9298.svg";
export { ForwardRef as ReactComponent };